const formatNumber = (value, locale, toFixed, precision) => (
  Number(Number((value).toPrecision(precision)).toFixed(toFixed)).toLocaleString(locale)
);

export default formatNumber;
